/** 
 * 
 */

export { default as IconOooh } from "./oooh-icon";
export * from "./oooh-icon.props";

